<template>
  <div>
    <div id="skipToContent">
      <a href="#contents">콘텐츠 바로가기 </a>
    </div>

    <!-- main -->
    <main class="dashBoard_promotion">
      <DashboardHeader  :abo="aboInfo.aboNo" :name="aboInfo.aboName"/>
      <!-- contents -->
      <div class="abo-dashboard">

        <div class="main-dash_section">
          <DashboardContentsAttainment
            @layer="showLayerAttinment"
            :attainmentlevel="attainment.level"/>

          <DashboardContentsAbocardList
            :abocardlist="aboCardList"
            :deadline="deadline"
            :isplatium="isPlatinum"/>
        </div>

        <DashboardLayerAttainmentMessage/>
      </div>
    </main>
    <!-- //main -->

    <DashboardLayerAttainment @layer="closeLayer"/>

  </div>
</template>

<script>
// Component
import DashboardHeader from './component/header.vue' // 상단-헤더
import DashboardContentsAttainment from './component/attainment.vue' // 달성정보-그래프(메인)
import DashboardContentsAbocardList from './component/abocardList.vue' // 구성원-목록
import DashboardLayerAttainment from './component/layerAttainment.vue' // layer-달성조건보기layer
import DashboardLayerAttainmentMessage from './component/layerAttainmentMessage.vue' // layer-목표달성

// Library
import Vue from 'vue'
import axios from 'axios'
import $ from 'jquery'
import VueConfetti from 'vue-confetti'

Vue.use(VueConfetti)

export default {
  name: 'salesDashboard',
  components: {
    DashboardHeader,
    DashboardContentsAttainment,
    DashboardContentsAbocardList,
    DashboardLayerAttainmentMessage,
    DashboardLayerAttainment,
  },
  data () {
    return {
      aboInfo: Object,
      attainment: Object({year: String('2023'), month: String('03'), level: Number(0), persent: Number(0)}),
      aboCardList: Object,
      aboOrderList: Object,
      aboOrderInfo: Object,
      effect_flag: String,
      deadline: String,
      objective: 30,
      isPlatinum: false
    }
  },
  methods: {
    init: async function () { // 초기화
      this.aboInfo = {aboNo: '', aboName: ''}
      this.orderinfo = {name: '', count: 0, agree: ''}
      this.attainment = {}
      this.aboCardList = []
      this.aboOrderInfo = {}
      this.effect_flag = 'N',
      this.deadline = 'Y'
      this.isPlatinum = false

      this.attainment = {year: '2023', month: '03', level: 0, persent: 0}
      await this.checkLogin() // 로그인 체크(회원번호,이름)
      await this.reset()
    },
    // 로그인 체크
    checkLogin: async function () {
      await axios.get(process.env.OCC_ROOT_URL + '/sso/authorizeEvent', {withCredentials: true}
      ).then(response => {
        if (response.data.header.status === 'ERROR') { // login fail
          window.location.href = process.env.AMWAY_ROOT_URL + '/login'
        } else if (response.data.customerUid != null && response.data.customerUid !== 'none') {
          // login success
          this.aboInfo.aboNo = atob(response.data.customerUid)
          this.aboInfo.aboName = response.data.name
        }
      }).catch(ex => {
        window.location.href = process.env.AMWAY_ROOT_URL + '/login'
      })
    },
    showLayerAttinment: function (layerId) {
      var targetLayer = document.querySelector('#' + layerId)
      targetLayer.classList.add('showing')
      $('html, body').addClass('scroll-off')
    },
    closeLayer: function () {
      let layers = document.querySelectorAll('.layer-area')
      $(layers).removeClass('showing')
      $('html, body').removeClass('scroll-off')
    },
    reset: async function () {
      await this.loadAttainment() // api 조회
      this.attainmentGrahp() // 목표달성 그래프
      this.attainmentEffect() // 목표달성 효과
    },
    attainmentEffect () {
      // TODO :: 목표달성 여부 체크
      if (this.attainment.level < this.objective) {
        $('.abo-dimmed').fadeOut()
      } else {
        if ( this.effect_flag === 'Y') {
          $('.abo-dimmed').show()
          this.$confetti.start({
            particles: [{type: 'rect'}],
            defaultColors: ['DodgerBlue', 'OliveDrab', 'Gold', 'pink', 'SlateBlue', 'lightblue', 'Violet', 'PaleGreen', 'SteelBlue', 'SandyBrown', 'Chocolate', 'Crimson']
          })

          this.loadEffectSave()

          setTimeout(() => {            
            this.$confetti.stop()
            this.$confetti.remove()
            $('.abo-dimmed').fadeOut()
          }, 3000)
        }
      }
    },
    attainmentGrahp () {
      // Dashboard 의 % 계산
      var segments = $('.chart-segment')
      var firstSegmentOffset = parseInt($(segments[0]).attr('stroke-dashoffset'))
      var preSegmentsTotalLength = this.attainment.persent

      for (var i = 0; i < segments.length; i++) {
        var progress = this.attainment.persent
        var radian = 2 * Math.PI * $(segments[i]).attr('r')

        progress = progress / 100
        progress = radian * (1 - progress)

        $(segments[i]).css({
          'strokeDasharray': radian,
          'strokeDashoffset': progress
          // radian
        })
        if (i !== 0) {
          var strokeDashoffset = 100 - preSegmentsTotalLength + firstSegmentOffset
          $(segments[i]).css('stroke-dashoffset', strokeDashoffset)
          preSegmentsTotalLength += this.attainment.persent
        }
      }
    },
    loadEffectSave: async function () {
      this.aboOrderList = []
      await axios.post(
        process.env.AWS_GATEWAY_URL_V2 + '/sales/dashboard-effect',
        {
          month: this.attainment.year + this.attainment.month,
          abo_no: this.aboInfo.aboNo
        }).then(response => {

          if (response.status === 200) {
            console.log('Amway Event LOG : Effect Off', response.data.statusMessage)
          } else {
            alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
          }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
      })
    },
    loadAttainment: async function () {
      this.aboCardList = []
      await axios.post(
        process.env.AWS_GATEWAY_URL_V2 + '/sales/dashboard',
        {
          month: this.attainment.year + this.attainment.month,
          abo_no: this.aboInfo.aboNo,
          type: 'abo'
        }).then(response => {
        if (response.status === 200) {
          if (response.data.achive.data == 0) {
            this.isPlatinum = false
            alert('해당 서비스는 3월 그룹 내 신규로 가입한 ABO가 있는 플래티늄 이상 ABO 리더님만 이용하실 수 있습니다.')
            // window.opener="Self"
            window.close()
            console.log(">>>>>> 닫았음")
          } else { 
            this.isPlatinum = true

            let attainmentCnt = (response.data.abo.data ? response.data.abo.data.length : 0) // 목표달성 조(Default 0) 지역변수
            this.attainment.level = attainmentCnt // 목표달성 조 설정
            this.attainment.persent = (attainmentCnt >= this.objective ? 100 : Math.round((attainmentCnt / this.objective) * 100)) // 목표달성 조 퍼센트
            this.deadline = (response.data.closed.data === 'N'? 'N' : "Y")
            this.effect_flag = (response.data.effect.data === 'N'? 'N' : "Y")
            
            this.aboCardList = []
            response.data.abo.data.forEach(item => { // ABO 목록 설정
              this.aboCardList.push({'number': item.ORD_IMC_NO, 'number_mask': item.ORD_IMC_NO, 'name': item.ORD_IMC_NM, 'amt': 0, 'persent': 0, 'privacy': item.PRIVACY_CD})
            })
          }
        } else {
          alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
      })
    }
  },
  mounted: function () {
    window.setTimeout(() => {
      this.init()
    }, 500)
  },
  created: function () {
    
    // 원화 포맷(number)
    Number.prototype.formatWon = function() {
      if(this==0) return 0
      var reg = /(^[+-]?\d+)(\d{3})/
      var n = (this + '');
      while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2')
      return n
    }

    // 원화 포맷(string)
    String.prototype.formatWon = function() {
      var num = parseFloat(this)
      if( isNaN(num) ) return "0"
      return num.formatWon()
    }

    // 날짜형태 포맷
    String.prototype.formatDate = function() {
      var num = this.substring(0,4) + '-' + this.substring(4,6) + '-' + this.substring(6,8)
      if( !isNaN(num) ) return this
      return num
    }

    // 이름 마스킹
    String.prototype.maskname = function() {
      let limit = 1
      var len = this.length
      var num = this.substring(0,limit) + this.substring(limit,len).replace(/\W/gi, "*")
      if( !isNaN(num) ) return this
      return num
    }

    // abo번호 마스킹
    String.prototype.maskabo = function() {
      let limit = 4
      var len = this.length
      var num = this.substring(0,limit) + this.substring(limit,len).replace(/\d/gi, "*")
      if( !isNaN(num) ) return this
      return num
    }
  }
}
</script>

<style scoped>
@import './assest/css/abo.css';
</style>



// WEBPACK FOOTER //
// src/views/sales/dashboard2/dashboard.vue